export class Role {
  public static readonly TemplateEditor = 'template_editor';
  public static readonly AutomatedTemplateEditor = 'automated_template_editor';
}
